import { lazy } from 'react';

// const Home = lazy(() => import('@src/pages/Homedemo/index'));
const Home = lazy(() => import('@src/pages/Home/index'));
// const Cart = lazy(() => import('@src/pages/Cartdemo/index'));
const List = lazy(() => import('@src/pages/Listdemo/index'));
const NewsCenter = lazy(() => import('@src/pages/NewsCenter/index'));
const AboutUs = lazy(() => import('@src/pages/AboutUs/index'));
const Consultation = lazy(() => import('@src/pages/Consultation/index'));
const TechnicalSupport = lazy(() => import('@src/pages/TechnicalSupport/index'));
const QualityInspectionDownload = lazy(() => import('@src/pages/QualityInspectionDownload/index'));
const Feedback = lazy(() => import('@src/pages/Feedback/index'));
const LoginAndRegiest = lazy(() => import('@src/pages/LoginAndRegiest/index'));
const Cart = lazy(() => import('@src/pages/Cart/index'));
const Product = lazy(() => import('@src/pages/Product/index'));
const ProductList = lazy(() => import('@src/pages/ProductList/index'));
const SearchEs = lazy(() => import('@src/pages/SearchEs/index'));
const ProductDetail = lazy(() => import('@src/pages/ProductDetail/index'));
const SettlementPage = lazy(() => import('@src/pages/SettlementPage/index'));
const NewsDetail = lazy(() => import('@src/pages/NewsDetail/index'));
const UserCenter = lazy(() => import('@src/pages/UserCenter/index'));
const OrderDetail = lazy(() => import('@src/pages/OrderDetail/index'));
const Forgotpassword = lazy(() => import('@src/pages/Forgotpassword/index'));
const SearchEsResult = lazy(() => import('@src/pages/SearchEsResult/index'));
const PayInfo = lazy(() => import('@src/pages/PayInfo/index'));
// const Login = lazy(() => import('@src/pages/Login/index'));

const routerList: any = [
  {
    path: '/',
    Component: Home,
  },
  {
    path: '/list',
    Component: List,
  },
  {
    path: '/cart',
    Component: Cart,
  },
  {
    path: '/NewsCenter',
    Component: NewsCenter,
  },
  {
    path: '/AboutUs',
    Component: AboutUs,
  },
  {
    path: '/Consultation',
    Component: Consultation,
  },
  {
    path: '/TechnicalSupport',
    Component: TechnicalSupport,
  },
  {
    path: '/QualityInspectionDownload',
    Component: QualityInspectionDownload,
  },
  {
    path: '/Feedback',
    Component: Feedback,
  },
  {
    path: '/Forgotpassword',
    Component: Forgotpassword,
  },
  {
    path: '/LoginAndRegiest',
    Component: LoginAndRegiest,
  },
  {
    path: '/Cart',
    Component: Cart,
  },
  // {
  //   path: '/ProductList',
  //   Component: ProductList,
  // },
  {
    path: '/SearchProductList',
    Component: SearchEs,
  },
  {
    path: '/SearchResult',
    Component: SearchEsResult,
  },
  {
    path: '/ProductDetail',
    Component: ProductDetail,
  },
  {
    path: '/SettlementPage',
    Component: SettlementPage,
  },
  {
    path: '/NewsDetail',
    Component: NewsDetail,
  },
  {
    path: '/UserCenter',
    Component: UserCenter,
  },
  {
    path: '/OrderDetail',
    Component: OrderDetail,
  },
  {
    path: '/PayInfo',
    Component: PayInfo,
  },
  // {
  //   path: '/Login',
  //   Component: Login,
  // },
];

export default routerList;
